<template>
	<v-dialog
		max-width="1200px"
		:model-value="show"
		@update:model-value="$emit('update:show', $event)"
		:fullscreen="$vuetify.display.xs"
	>
		<v-card>
			<div class="card-top p-2">
				<span class="card-title">{{
					dayjs(eventDay?.start).format("dddd, MMMM D, YYYY")
				}}</span>
				<v-btn
					data-cy="close-modal-btn"
					style="border-radius: 30px"
					@click="$emit('update:show', false)"
					icon
					size="large"
					><v-icon>mdi-close</v-icon></v-btn
				>
			</div>

			<div class="card-body p-4">
				<div>
					<span style="color: rgb(100, 100, 100); font-size: 1.1rem">{{ name }}</span>
					<CopyBreaksToTeams
						v-if="type === 'teacher' && show && dayId"
						:teacher-uid="uid"
						:teacher-name="name"
						:day-label="
							eventDay?.start
								? dayjs(eventDay.start).format('dddd, MMMM D, YYYY')
								: 'this day'
						"
						:conference-days-ids="[dayId]"
					/>
				</div>

				<div class="table-overflow-hide">
					<div
						class="directoryTable scrollable-55vh"
						style="max-height: 55vh; height: auto"
					>
						<table class="table">
							<thead class="sticky-header">
								<tr>
									<th class="small-col">Time</th>
									<th>Meeting</th>
									<th class="small-col">Comments</th>
									<th class="small-col"></th>
								</tr>
							</thead>
							<tbody v-if="Array.isArray(schedule)">
								<tr
									v-for="(item, i) in schedule"
									:key="item.pta_id || item.timeslot"
									:class="{ 'extra-seat-row': 'extraSeat' in item }"
								>
									<td style="white-space: nowrap">
										{{ dayjs(item.timeslot).format("h:mm A") }}
									</td>
									<td style="width: 100%">
										<template v-if="item.flag == 'R'">
											<div
												class="meeting-wrapper"
												v-if="!state.showComment.includes(item.pta_id)"
											>
												<!-- <div :class="['meeting-item', { team: !!item.team_uid }]"> -->
												<div :class="['meeting-item']">
													<div class="meeting-items-flex">
														<span class="meeting-item-col" v-if="item.team_uid">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
																>Team</typography
															>
															<Typography
																color="gray700"
																class="pl-3"
																weight="400"
																transform="capitalize"
															>
																{{ item.team_name }}
															</Typography>
														</span>
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
																>Parent</typography
															>
															<typography
																color="gray700"
																class="pl-3"
																weight="400"
																transform="capitalize"
															>
																{{ item.parent_name }}
															</typography>
														</span>
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
															>
																Student
															</typography>
															<typography
																color="gray700"
																class="pl-3"
																weight="400"
																transform="capitalize"
															>
																{{ item.child_name }}
															</typography>
														</span>
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
															>
																Meeting Type
															</typography>
															<div class="pl-3">
																<v-menu
																	v-model="state.showMeetingTypeMenu[item.pta_id]"
																	location="bottom"
																>
																	<template v-slot:activator="{ props: menuProps }">
																		<v-btn
																			v-bind="menuProps"
																			variant="text"
																			size="small"
																			:loading="state.loadingMeetingType.includes(item.pta_id)"
																			class="pa-0 text-capitalize"
																			style="min-width: auto; text-transform: capitalize;"
																		>
																			{{ formatMeetingTypeLabel(item.meeting_type) }}
																			<v-icon size="small" class="ml-1">mdi-chevron-down</v-icon>
																		</v-btn>
																	</template>
																	<v-list>
																		<v-list-item
																			v-for="type in getAvailableMeetingTypes(item.meeting_types)"
																			:key="type.value"
																			@click="updateMeetingType(item, type.value)"
																			:active="item.meeting_type === type.value"
																		>
																			<v-list-item-title>{{ type.label }}</v-list-item-title>
																		</v-list-item>
																	</v-list>
																</v-menu>
															</div>
														</span>
														
														<MeetingTypeView
															:conference-day="eventDay"
															use-agenda-types
															:agenda="item"
														></MeetingTypeView>
														<span class="meeting-item-col" v-if="item.translator_language">
															<component :is="codeToIcon[item.translator_language] || codeToIcon['en']" class="me-2" style="width:20px;height:20px" />
																{{ $t('message.AgendaCard.translator_requested', { language: getLanguageName(item.translator_language) }) }}
														</span>
													</div>
												</div>
											</div>
											<div v-else>
												<v-textarea
													:rows="3"
													:model-value="
														state.comments.find((i) => i[0] === item.pta_id)?.[1] ??
														item.comment
													"
													@update:model-value="
                            {
                              if (state.comments.find((i) => i[0] === item.pta_id)) {
                                state.comments.find((i) => i[0] === item.pta_id)![1] = $event;
                              } else {
                                state.comments.push([item.pta_id, $event]);
                              }
                            }
                          "
													variant="outlined"
													color="primary"
												>
												</v-textarea>
											</div>
											<v-btn
												v-if="
													schedule[i + 1]?.timeslot !== item.timeslot &&
													!schedule.some((s) => s.timeslot === item.timeslot && s.flag !== 'R') &&
													schedule.filter((s) => s.timeslot === item.timeslot).length < (seats || 1)
												"
												variant="text"
												size="small"
												color="primary"
												class="add-seat-btn mt-1 px-1"
												prepend-icon="mdi-plus"
												@click="
													schedule.splice(i + 1, 0, { timeslot: item.timeslot, extraSeat: true } as any);
													state.showAdd = item.timeslot;
												"
												data-cy="add-seat-btn"
											>
												<span class="font-weight-bold">Add</span>
												<span class="add-seat-left ml-1">
													({{ (seats || 1) - schedule.filter((s) => s.timeslot === item.timeslot).length }}
													{{ (seats || 1) - schedule.filter((s) => s.timeslot === item.timeslot).length === 1 ? "seat" : "seats" }}
													left)
												</span>
											</v-btn>
										</template>
										<template v-if="item.flag == 'N'">
											<div class="break-wrapper">
												<div class="break-item">
													<typography
														color="secondary"
														class="pl-6"
														weight="600"
														transform="uppercase"
														>Break Time / Unavailable</typography
													>
												</div>
											</div>
										</template>
										<template v-if="['O', 'T'].includes(item.flag)">
											<div class="break-wrapper">
												<div class="break-item">
													<span class="meeting-items-flex">
														<span class="meeting-item-col">
															<typography
																color="primary400"
																weight="600"
																transform="uppercase"
																>{{
																	item.flag === "O" ? "Teacher meeting" : "Team meeting"
																}}</typography
															>

															<typography
																v-if="item.flag !== 'O' || 'teacher_name' in item"
																color="gray700"
																weight="400"
																transform="capitalize"
																class="pl-3"
															>
																{{
                                  item.flag === "O" ? (item as any).teacher_name : item.team_name
																}}
															</typography>
														</span>
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
																>Parent</typography
															>
															<typography
																color="gray700"
																weight="400"
																transform="capitalize"
																class="pl-3"
															>
																{{ item.parent_name }}
															</typography>
														</span>
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
															>
																Student
															</typography>
															<typography
																color="gray700"
																weight="400"
																transform="capitalize"
																class="pl-3"
															>
																{{ item.child_name }}
															</typography>
														</span>
														<template v-if="item.flag == 'T'">
														<span class="meeting-item-col">
															<typography
																color="gray700"
																weight="600"
																transform="uppercase"
															>
																Meeting Type
															</typography>
															<div class="pl-3">
																<v-menu
																	v-model="state.showMeetingTypeMenu[item.pta_id]"
																	location="bottom"
																>
																	<template v-slot:activator="{ props: menuProps }">
																		<v-btn
																			v-bind="menuProps"
																			variant="text"
																			size="small"
																			:loading="state.loadingMeetingType.includes(item.pta_id)"
																			class="pa-0 text-capitalize"
																			style="min-width: auto; text-transform: capitalize;"
																		>
																			{{ formatMeetingTypeLabel(item.meeting_type) }}
																			<v-icon size="small" class="ml-1">mdi-chevron-down</v-icon>
																		</v-btn>
																	</template>
																	<v-list>
																		<v-list-item
																			v-for="type in getAvailableMeetingTypes(item.meeting_types)"
																			:key="type.value"
																			@click="updateMeetingType(item, type.value)"
																			:active="item.meeting_type === type.value"
																		>
																			<v-list-item-title>{{ type.label }}</v-list-item-title>
																		</v-list-item>
																	</v-list>
																</v-menu>
															</div>
														</span>
														
														<MeetingTypeView
																:conference-day="eventDay"
																use-agenda-types
																:agenda="item"
															></MeetingTypeView
														></template>
													</span>
												</div></div
										></template>
										<template v-if="!item.flag && state.showAdd !== item.timeslot">
											<div class="empty-wrapper" data-cy="empty-meeting-slot">
												<div class="empty-row">
													<v-btn
														color="secondary"
														variant="text"
														@click="state.showAdd = item.timeslot"
														:disabled="state.loadingBreaks.includes(item.timeslot)"
														data-cy="add-meeting-btn"
													>
														<template #prepend>
															<v-icon color="primary-300">mdi-plus-circle</v-icon>
														</template>
														<typography
															color="primary"
															weight="600"
															transform="capitalize"
														>
															Add Meeting</typography
														></v-btn
													>
												</div>
												<div class="empty-row">
													<v-btn
														color="secondary"
														variant="text"
														@click="addBreak(item.timeslot)"
														:loading="state.loadingBreaks.includes(item.timeslot)"
														data-cy="add-break-btn"
													>
														<template #prepend>
															<v-icon color="secondary300">mdi-coffee</v-icon>
														</template>
														<typography
															color="secondary"
															weight="600"
															transform="capitalize"
														>
															Add break time</typography
														></v-btn
													>
												</div>
											</div>
										</template>
										<template v-if="!item.flag && state.showAdd == item.timeslot">
											<div class="d-flex flex-column gap-2">
												<div class="d-flex gap-2">
													<Autocomplete
														style="flex: 1"
														:max-items="50"
														label="Parent"
														v-model="form.parent"
														:items="parents"
														item-title="title"
														item-value="value"
														variant="outlined"
														class="custom-input"
														density="comfortable"
														color="primary"
														clearable
														:loading="loadingStudent && parents.length <= 1"
														data-cy="parent-select"
														:item-props="{
															'data-cy': 'parent-select-item',
														}"
													></Autocomplete>
													<autocomplete
														style="flex: 1"
														:max-items="50"
														label="Student"
														v-model="form.student"
														:items="students"
														item-title="title"
														item-value="value"
														variant="outlined"
														class="custom-input"
														density="comfortable"
														color="primary"
														clearable
														:loading="loadingParent && students.length <= 1"
														data-cy="student-select"
														:item-props="{
															'data-cy': 'student-select-item',
														}"
													></autocomplete>
												</div>
												<div v-if="'extraSeat' in item" class="extra-seat-note">
													New seat in the {{ dayjs(item.timeslot).format("h:mm A") }} slot (seat
													{{ schedule.filter((s) => s.timeslot === item.timeslot).length }} of
													{{ seats || 1 }})
												</div>
											</div>
										</template>
									</td>

									<td class="small-col">
										<template v-if="item.flag === 'R'">
											<div
												class="d-flex gap-2"
												style="cursor: pointer; width: fit-content"
												v-if="!state.showComment.includes(item.pta_id)"
												@click="state.showComment.push(item.pta_id)"
											>
												<v-icon color="rgb(120,120,120)">mdi-pencil</v-icon>
												<span style="white-space: nowrap; color: gray; font-weight: 600"
													>Edit Comment</span
												>
											</div>
											<div v-else class="d-flex gap-2">
												<v-btn
													style="border-radius: 4px"
													size="small"
													:loading="state.loadingComment.includes(item.pta_id)"
													@click="addComment(item)"
													>Save</v-btn
												>
												<v-btn
													style="border-radius: 4px"
													size="small"
													color="gray"
													variant="tonal"
													@click="
														state.comments = state.comments.filter(
															(i) => i[0] !== item.pta_id
														);
														state.showComment = state.showComment.filter(
															(i) => i !== item.pta_id
														);
													"
													:disabled="state.loadingComment.includes(item.pta_id)"
												>
													Discard
												</v-btn>
											</div>
										</template>
										<div
											v-if="!item.flag && state.showAdd === item.timeslot"
											class="d-flex gap-2"
										>
											<v-btn
												style="border-radius: 4px"
												size="small"
												:loading="state.loadingSave.includes(item.timeslot)"
												:disabled="!form.parent && !form.student"
												@click="addMeeting(item.timeslot)"
												data-cy="save-add-meeting"
												>Save</v-btn
											>
											<v-btn
												style="border-radius: 4px"
												size="small"
												color="gray"
												variant="tonal"
												@click="
													if ('extraSeat' in item) schedule.splice(i, 1);
													state.showAdd = '';
													form.parent = '';
													form.student = '';
													form.meetingType = '';
												"
												:disabled="state.loadingSave.includes(item.timeslot)"
												data-cy="cancel-add-meeting"
												>Cancel</v-btn
											>
										</div>
									</td>
									
									<td>
										<div v-if="['R', 'N'].includes(item.flag)">
											<v-btn
												@click="deleteSchedule(item.pta_id)"
												style="height: 30px; width: 30px; border-radius: 20px"
												icon
												color="normal"
												:loading="state.loadingDelete.includes(item.pta_id)"
												><v-icon>mdi-trash-can-outline</v-icon></v-btn
											>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-if="!schedule?.length && loadingSchedule" style="width: 100%">
					<LoadingState text="Loading Schedule..."></LoadingState>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import type {
	DayWithNested,
	GuardianType,
	StudentType,
	TeacherType,
	TeamType,
} from "@/api_types/school";
import type { GetSchedule } from "@/api_types/teacher";
import Autocomplete from "@/components/autocomplete.vue";
import MeetingTypeView from "@/components/global/MeetingTypeView.vue";
import LoadingState from "@/components/loadingState.vue";
import CopyBreaksToTeams from "./CopyBreaksToTeams.vue";
import Typography from "@/components/typography.vue";
import FetchService from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";
import { useSchoolStore } from "@/stores/school";
import useParents from "@/stores/school/parents";
import useStudents from "@/stores/school/students";
import { tryCatch } from "@/utils";
import { asyncComputed } from "@/utils/asyncComputed";
import dayjs from "dayjs";
import { computed } from "vue";
import { reactive } from "vue";
import { getLanguageName } from "@/composables/useLanguage.js";

import enFlag from '@/assets/icons/flags/usa.svg';
import esFlag from '@/assets/icons/flags/es.svg';
import frFlag from '@/assets/icons/flags/fr.svg';
import deFlag from '@/assets/icons/flags/de.svg';
import arFlag from '@/assets/icons/flags/ar.svg';
import zhFlag from '@/assets/icons/flags/cn.svg';
import jaFlag from '@/assets/icons/flags/jp.svg';
import bnFlag from '@/assets/icons/flags/bd.svg';
import krFlag from '@/assets/icons/flags/kr.svg';
import urFlag from '@/assets/icons/flags/pk.svg';
import woFlag from '@/assets/icons/flags/sn.svg';
import ruFlag from '@/assets/icons/flags/ru.svg';
import uaFlag from '@/assets/icons/flags/ua.svg';
import uzFlag from '@/assets/icons/flags/uz.svg';
import geFlag from '@/assets/icons/flags/ge.svg';
import hkFlag from '@/assets/icons/flags/hk.svg';
import htFlag from '@/assets/icons/flags/ht.svg';
import nlFlag from '@/assets/icons/flags/nl.svg';
import viFlag from '@/assets/icons/flags/vi.svg';
import itFlag from '@/assets/icons/flags/it.svg';
import ptFlag from '@/assets/icons/flags/pt.svg';

const codeToIcon: Record<string, any> = {
	en: enFlag,
	es: esFlag,
	fr: frFlag,
	de: deFlag,
	ar: arFlag,
	zh: zhFlag,
	ja: jaFlag,
	bn: bnFlag,
	ko: krFlag,
	ur: urFlag,
	wo: woFlag,
	ru: ruFlag,
	uk: uaFlag,
	"zh-cn": zhFlag,
	uz: uzFlag,
	ka: geFlag,
	yue: hkFlag,
	ht: htFlag,
	nl: nlFlag,
	vi: viFlag,
	it: itFlag,
	pt: ptFlag,
};



const parseMeetingType = (type) => {
	if (type === "in_person") return "In Person";
	return type || "Not Available";
};

const formatMeetingTypeLabel = (type: string | null): string => {
	if (!type) return "Not Available";
	if (type === "in_person") return "In Person";
	return type.charAt(0).toUpperCase() + type.slice(1);
};

const getAvailableMeetingTypes = (meetingTypes: any): Array<{ value: string; label: string }> => {
	if (!meetingTypes) return [];
	
	// Handle case where meeting_types might be a string
	const types = typeof meetingTypes === "string" ? JSON.parse(meetingTypes) : meetingTypes;
	
	const availableTypes: Array<{ value: string; label: string }> = [];
	
	if (types.in_person) availableTypes.push({ value: "in_person", label: "In Person" });
	if (types.virtual) availableTypes.push({ value: "virtual", label: "Virtual" });
	if (types.phone) availableTypes.push({ value: "phone", label: "Phone" });
	if (types.callback) availableTypes.push({ value: "callback", label: "Callback" });
	
	return availableTypes;
};

const state = reactive({
	showAdd: "",
	loadingBreaks: [] as string[],
	loadingSave: [] as string[],
	loadingDelete: [] as number[],
	showComment: [] as number[],
	loadingComment: [] as number[],
	comment: null as null | string,
	comments: [] as [number, string][],
	loadingMeetingType: [] as number[],
	showMeetingTypeMenu: {} as Record<number, boolean>,
});

const form = reactive({
	student: "",
	parent: "",
	meetingType: "",
});

const props = defineProps<{
	eventDay: DayWithNested;
	dayId: string;
	uid: string;
	type: "teacher" | "team";
	show: boolean;
	name: string;
	seats?: number;
}>();

const {
	data: schedule,
	loading: loadingSchedule,
	reload: reloadSchedule,
} = asyncComputed(
	async (controller) => {
		if (!props.show || !props.uid || !props.dayId) return [];
		const res = ((await FetchService.fetchData(
			`/schedule?${props.type}_uid=${props.uid}&conference_days_id=${props.dayId}`,
			"get",
			undefined,
			undefined,
			controller
		)) as GetSchedule[])?.map?.((i) => ({
			...i,
			meeting_types:
				typeof i.meeting_types == "string"
					? tryCatch(() => JSON.parse(i.meeting_types as any), {})
					: i.meeting_types,
		}));
		return res;
	},
	[() => props.dayId, () => props.type, () => props.uid, () => props.show],
	undefined,
	false, // keep the rows on screen while reloading after an add/delete
	[]
);

const parentsStore = useParents();
const studentsStore = useStudents();
const schoolStore = useSchoolStore();

const {
	data: selectedData,
	loading: loadingSelected,
	reload: reloadSelected,
} = asyncComputed(
	async (controller) => {
		form.student = "";
		form.parent = "";
		form.meetingType = "";
		// console.log(props);

		let endpoint =
			props.type == "teacher" ? `/teachers/${props.uid}` : `/teams/${props.uid}`;
		if (!props.uid) return {} as TeacherType | TeamType;
		const res = (await FetchService.fetchData(
			endpoint,
			"get",
			undefined,
			undefined,
			controller
		)) as TeacherType | TeamType;

		return res;
	},
	[() => props.uid],
	undefined,
	undefined,
	{}
);

const { data: parentData, loading: loadingParent } = asyncComputed(
	async (controller) => {
		if (!form.parent) return {} as GuardianType;
		const res = (await FetchService.fetchData(
			`/guardians/${form.parent}`,
			"get",
			undefined,
			undefined,
			controller
		)) as GuardianType;

		return res;
	},
	[() => form.parent],
	undefined,
	undefined,
	{}
);

const { data: studentData, loading: loadingStudent } = asyncComputed(
	async (controller) => {
		if (!form.student) return {} as StudentType;
		const res = (await FetchService.fetchData(
			`/students/${form.student}`,
			"get",
			undefined,
			undefined,
			controller
		)) as StudentType;

		return res || {};
	},
	[() => form.student],
	undefined,
	undefined,
	{}
);

const parents = computed(() => {
	let list: { title: string; value: string }[] = [];
	if (form.student) {
		if (loadingStudent.value && form.parent) {
			list = parentsStore.parents.data
				.filter((g) => g.uid === form.parent && (!g.deleted || g.deleted == 'no'))
				.map((i) => ({
					title: `${i.firstname} ${i.lastname}`,
					value: i.uid,
				}));
		} else {
			list =
				studentData.value.guardians
					?.filter((i) => !i.deleted || i.deleted == 'no')
					.map((i) => ({
						title: `${i.firstname} ${i.lastname}`,
						value: i.uid,
					})) || [];
		}
	} else {
		if (schoolStore.schoolDetails.data?.integration === "none") {
			list = parentsStore.parents.data
				.filter((g) => !g.deleted || g.deleted == 'no')
				.map((i) => ({
					title: `${i.firstname} ${i.lastname}`,
					value: i.uid,
				}));
		} else {
			list = (selectedData.value.guardians as
				| TeamType["guardians"]
				| TeacherType["guardians"])
				.filter((i) => !i.deleted || i.deleted == 'no')
				.map((i) => ({
					title: `${i.firstname} ${i.lastname}`,
					value: i.uid,
				}));
		}
	}
	// Ensure the selected parent is always in the list
	if (form.parent && !list.find((p) => p.value === form.parent)) {
		// Try to get the parent from parentData or parentsS.parents.data
		let parent = null;
		if (parentData.value && parentData.value.uid === form.parent) {
			parent = parentData.value;
		} else {
			parent = parentsStore.parents.data.find((g) => g.uid === form.parent);
		}
		if (parent && (!parent.deleted || parent.deleted == 'no')) {
			list = [
				...list,
				{
					title: `${parent.firstname} ${parent.lastname}`,
					value: parent.uid,
				},
			];
		}
	}
	return list;
});

const availableMeetingTypes = computed(() => {
	return getAvailableMeetingTypes(props.eventDay?.meeting_types);
});

const students = computed(() => {
	if (form.parent) {
		if (loadingParent.value && form.student) {
			return studentsStore.students.data
				.filter((s) => s.uid === form.student && !s.deleted)
				.map((i) => ({
					title: `${i.child_fname} ${i.child_lname}`,
					value: i.uid,
				}));
		}
		return (
			parentData.value.students
				?.filter((i) => !i.deleted || i.deleted == 'no')
				.map((i) => ({
					title: `${i.child_fname} ${i.child_lname}`,
					value: i.uid,
				})) || []
		);
	} else {
		console.log("Loading students");
		if (schoolStore.schoolDetails.data?.integration === "none") {
			return studentsStore.students.data
				.filter((s) => !s.deleted || s.deleted == 'no')
				.map((i) => ({
					title: `${i.child_fname} ${i.child_lname}`,
					value: i.uid,
				}));
		}
		console.log("Selected data", selectedData.value);
		return (selectedData.value.students as TeacherType["students"])
			.filter((i) => !i.deleted ||  i.deleted == 'no')
			.map((i) => ({
					title: `${i.child_fname} ${i.child_lname}`,
					value: i.uid,
				})) || [];
			// .map((i: TeacherType["students"][number] | TeamType["students"][number]) => {
			// 	title: `${i.child_fname} ${i.child_lname}`,
			// 	value: i.uid,
			// }
				// if ("enrollment" in g) {
				// 	return g.enrollment.map((i) => ({
				// 		title: `${i.child_fname} ${i.child_lname}`,
				// 		value: i.uid,
				// 	}));
				// }
				// if ("teamenrollment" in g) {
				// 	return g.teamenrollment.map((i) => ({
				// 		title: `${i.child_fname} ${i.child_lname}`,
				// 		value: i.uid,
				// 	}));
				// }
			// })
			// .flat();
	}
});

const addBreak = async (timeslot: string) => {
	state.loadingBreaks.push(timeslot);
	const res = await FetchService.fetchData("/schedule/unavailable", "post", {
		[props.type + "_uid"]: props.uid,
		conference_days_id: props.dayId,
		timeslot,
	});
	if (res?.appointment) {
		const index = schedule.value?.findIndex((s) => s.timeslot === timeslot);
		schedule.value![index] = res.appointment;
	}
	state.loadingBreaks = state.loadingBreaks.filter((s) => s !== timeslot);
};

const deleteSchedule = async (pta_id: number) => {
	state.loadingDelete.push(pta_id);
	await FetchService.fetchData("/schedule/" + pta_id, "delete");
	reloadSchedule();
	state.loadingDelete = state.loadingDelete.filter((i) => i !== pta_id);
};

const addMeeting = async (timeslot: string) => {
	state.loadingSave.push(timeslot);
	const appointment: any = {
		children_uid: form.student,
		parent_uid: form.parent,
		[`${props.type}_uid`]: props.uid,
		timeslot: timeslot,
		conference_id: props.eventDay.conference_id,
		conference_days_id: props.eventDay.conference_days_id,
	};
	
	// Add meeting_type if set
	if (form.meetingType) {
		appointment.meeting_type = form.meetingType;
	}
	
	const res = await FetchService.fetchData("/schedule", "post", {
		appointment,
	});

	if (res?.pta_id) {
		state.showAdd = "";
		reloadSchedule();
		if (state.loadingSave.length == 1) {
			form.student = "";
			form.parent = "";
			form.meetingType = "";
		}
	} else {
		useAlertsStore().addAlert("error", res.message);
	}
	state.loadingSave = state.loadingSave.filter((i) => i !== timeslot);
};
const addComment = async (meeting: GetSchedule) => {
	state.loadingComment.push(meeting.pta_id);

	const res = await FetchService.fetchData("/meetingdetail/" + meeting.pta_id, "put", {
		message: state.comments.find((i) => i[0] === meeting.pta_id)?.[1] || null,
	});
	if (res?.pta_id) meeting.comment = res.message;

	state.loadingComment = state.loadingComment.filter((i) => i !== meeting.pta_id);
	state.showComment = state.showComment.filter((i) => i !== meeting.pta_id);
};

const updateMeetingType = async (meeting: GetSchedule, meetingType: string) => {
	state.loadingMeetingType.push(meeting.pta_id);
	state.showMeetingTypeMenu[meeting.pta_id] = false;
	
	const details = {
		pta_id: meeting.pta_id,
		meeting_type: meetingType
	};
	
	const resp = await FetchService.fetchData(
		`/meetingdetail/${meeting.pta_id}`,
		"put",
		details
	);
	
	if (resp) {
		// Update local state
		meeting.meeting_type = meetingType;
		reloadSchedule();
	}
	
	state.loadingMeetingType = state.loadingMeetingType.filter((i) => i !== meeting.pta_id);
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
@use "sass:map";

.empty-wrapper {
	display: flex;
	align-items: center;
	min-height: 45px;
	gap: 10px;
	flex-wrap: wrap;
	.empty-row {
		min-height: 45px;
		background-color: $primary-25;
		border: 1px solid $primary-75;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}
}

.break-wrapper {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	.break-item {
		min-height: 45px;
		background-color: $secondary-50;
		border: 1px solid $secondary;
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 4px;
		padding: 0 10px;
	}
}

.small-col {
	width: 0px;
}

.add-seat-btn {
	font-size: 0.8125rem;
	text-transform: none;
	letter-spacing: normal;
	height: auto !important;
	min-height: 24px;
	.add-seat-left {
		font-weight: 400;
		color: $gray-600;
	}
}

.extra-seat-row td {
	background-color: #fffbeb;
}

.extra-seat-note {
	font-size: 0.8rem;
	color: $gray-600;
}

.meeting-wrapper {
	display: flex;
	align-items: center;
	min-height: 45px;
	gap: 10px;
	flex-wrap: wrap;

	.meeting-item {
		display: flex;
		justify-content: space-between;
		min-height: 45px;
		background-color: $primary-25;
		border: 1px solid $primary-75;
		flex: 1;
		align-items: center;
		border-radius: 4px;
		padding: 0 10px;
		width: 100%;

		&.team {
			background-color: $primary-100;
		}
	}
}

.meeting-items-flex {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	width: 100%;
	gap: 1px 13px;
	:deep(.meeting-item-col) {
		display: flex;
		> span {
			white-space: nowrap;
		}
	}
}

.card-top {
	display: flex;
	align-items: center;
	background-color: $primary;
	min-width: 100%;
	justify-content: space-between;
	.card-title {
		font-weight: 600;
		font-size: 1.25rem;
		margin: auto 0 auto 20px;
		color: white;
	}
}

.card-body {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.scrollable-55vh {
	max-height: 55vh;
	height: 55vh;
	overflow: auto;
	margin-top: 1rem; // Instead of @extend .mt-3
	.table {
		margin-top: 0; // Instead of @extend .mt-0
	}
}

.directoryTable {
	overflow-x: auto; // Instead of @extend .table-responsive
	table {
		margin-top: 1rem; // Instead of @extend .mt-3
		width: 100%; // Instead of @extend .table
		background-color: white; // Instead of @extend .bg-white
		margin-bottom: 0; // Instead of @extend .mb-0
		border: solid 1px $gray-300;

		thead th {
			font-weight: $font-weight-medium;
			white-space: nowrap;
			color: $gray-600;
			font-size: 0.75rem;
			text-transform: uppercase;
			letter-spacing: 0.075em;
		}
		tbody {
			border-top: none !important;
			td {
				vertical-align: middle;
			}
			td:first-child {
				width: 28px;
			}
			td:nth-child(2) {
				width: 250px;
			}
		}
		.icon {
			width: 75px;
			height: 25px;
		}
		> :not(caption) > * > * {
			background-color: unset; //remove BS default
		}
	}
	+ h3 {
		margin-top: 3rem;
	}

	.sticky-header tr {
		position: sticky;
		top: 0;
		background-color: $gray-200;
		z-index: 1; /* Increase the z-index value */
		th {
			// color: $white !important;
			font-size: medium !important;
			font-size: 0.85rem;
			// padding: unset;
			vertical-align: middle;
			// text-align: center;
		}
	}
	border-collapse: separate;
	border-spacing: 0;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
}
</style>
